module.exports = __webpack_public_path__ + "static/kentpark-sm-06f6cffaab304b7cc356bdc246612a33.jpg";